var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSliderLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7071 22.7071C13.0976 22.3166 13.0976 21.6834 12.7071 21.2929L2.91421 11.5L12.7071 1.70711C13.0976 1.31658 13.0976 0.683418 12.7071 0.292892C12.3166 -0.0976315 11.6834 -0.0976315 11.2929 0.292892L0.0857873 11.5L11.2929 22.7071C11.6834 23.0976 12.3166 23.0976 12.7071 22.7071Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderLeftArrow);
export default __webpack_public_path__ + "static/media/sliderLeftArrow.0700b61c950bfa019850e9046343f459.svg";
export { ForwardRef as ReactComponent };